export const enUS_login = {
   'login.id': '아이디',
   'login.password': '비밀번호',
   'login.saveId': '아이디 저장',
   'login.button.login': '로그인',
   'login.button.findId': '아이디 찾기',
   'login.button.initPassword': '비밀번호 초기화',
   'login.ment.register': '계정이 없으신가요?',
   'login.button.register': '회원가입',
   'login.err.input': '아이디나 비밀번호가 입력되지 않았습니다. 다시 확인해 주세요.',
   'login.err.email': '해당 아이디를 찾을 수 없습니다. 다시 확인해 주세요.',
   'login.err.password': '비밀번호가 일치하지 않습니다. 다시 확인해 주세요.',
   'login.err.notApprove': '아직 승인되지 않은 아이디입니다. 관리자에게 문의해 주세요.',
   'login.err.count': '비밀번호 입력 횟수를 초과하였습니다. 비밀번호를 초기화해 주세요.',

   'findId.tab.findId': '아이디 찾기',
   'findId.tab.initPassword': '비밀번호 초기화',
   'findId.title.findId': '아이디가 기억나지 않으세요?',
   'findId.ment.findId': '회원가입시 기재하셨던 회원정보를 입력해 주세요.',
   'findId.company': '회사명',
   'findId.manager': '담당자',
   'findId.phone': '핸드폰번호',
   'findId.button': '아이디 찾기',
   'findId.err.company': '회사명이 입력되지 않았습니다. 다시 확인해 주세요.',
   'findId.err.manager': '담당자가 입력되지 않았습니다. 다시 확인해 주세요.',
   'findId.err.phone': '핸드폰번호가 입력되지 않았습니다. 다시 확인해 주세요.',
   'findId.title.complete': '고객님 아이디 찾기가 완료 되었습니다.',
   'findId.ment.complete': '개인정보 도용에 대한 피해방지를 위하여 아이디 일부는 **처리합니다.',
   'findId.detail1.complete': '회원님의 아이디는',
   'findId.detail2.complete': '(으)로 등록되어 있습니다.',
   'findId.complete.button': '로그인 페이지로 가기',

   'initPassword.title.initPassword': '비밀번호가 기억나지 않으세요?',
   'initPassword.title.complete': '임시 비밀번호가 발급되었습니다.',
   'initPassword.ment.complete': '발급된 임시 비밀번호는 다시 조회가 불가능하며 가입 시 입력된 메일로 발송되었습니다.\n로그인 후 꼭 비밀번호를 변경하십시오.',
   'initPassword.email': '아이디',
   'initPassword.button': '비밀번호 초기화',
   'initPassword.err.email': '아이디가 입력되지 않았습니다. 다시 확인해 주세요.',


   'footer.ment': '문의사항은 유케이미디어로 연락 주세요.',
   'footer.info': '｜대표번호｜02-0000-0000 ｜이메일｜support@ukmedia.co.kr',

   'findId.err.title': '일치하는 회원정보가 없습니다.',
   'findId.err.ment': '입력하신 정보와 일치하는 회원이 없습니다.\n정보를 다시 확인해 주세요.',
   'findId.err.footer': '본인의 정보를 찾지 못하신 경우엔 하단의 전화나 이메일로 문의해 주세요.\n전화나 이메일 문의 시 본인확인 절차가 다소 까다롭거나 시간이 지체될 수 있습니다.',
   'findId.err.info': '｜대표번호｜02-0000-0000 ｜이메일｜support@ukmedia.co.kr',

   'register.title': '회원가입',

   'register.step.1': '약관동의',
   'register.step.2': '정보입력',
   'register.step.3': '승인대기',
   'register.step.4': '가입완료',

   'register.terms.title': 'UKMEDIA 회원 이용약관',
   'register.terms.ment': 'UKMEDIA 서비스이용을 위해 아래 이용약관 및 정보이용에 동의해 주세요.',
   'register.terms.name.all': '전체동의',
   'register.terms.name.uk': 'UKMEDIA 이용약관에 동의',
   'register.terms.name.priavte': '개인(신용)정보 수집 및 이용동의',
   'register.terms.name.company': '기업회원(신용)정보 수집 및 이용동의',
   'register.terms.essential': '(필수)',
   'register.terms.error': '필수 약관에 동의해 주세요',

   'register.terms.content.uk': '1. 수집하는 개인정보의 항목\n회사는 회원가입, 상담, 서비스 신청 등을 위해 아래와 같은 개인정보를 수집하고 있습니다\n개인정보 수집방법에 따라 수집항목이 추가될 수 있습니다.\n\n\n1) 기본항목 수집방법 : 홈페이지 회원가입 및 서비스 제공에 관한 계약 이행시\n- 수집항목(필수) : 이름, 생년월일, 성별, 로그인ID, 비밀번호, 이메일, 휴대전화번호, 희망과정, 본인식별 정보 (아이핀인증가입시 DI)\n- 수집항목(선택) : 주소, 직업, 학력, 계좌번호, 추천인ID\n2) 추가항목 수집방법 : 학점은행 과정 수강신청시 최초1회\n\n- 수집항목 : 주민등록번호\n- 근거법령 : 학점인정 등에 관한 법률 시행령 제19조 2항\n3) 추가항목 수집방법 : 간편 로그인 사용시(SNS 계정 이용)\n\n- 네이버 계정 이용시 : 별명\n- 카카오 계정 이용시 : 프로필사진, 닉네임\n2. 개인정보의 수집 및 이용목적\n회사는 수집한 개인정보를 다음의 목적을 위해 활용합니다.\n\n-서비스 제공에 관한 계약 이행 및 서비스 제공에 따른 요금정산 : 콘텐츠 제공, 구매 및 요금 결제 , 물품배송 또는 청구지 등 발송\n-회원 관리 : 회원제 서비스 이용에 따른 본인확인 , 개인 식별 , 가입 의사 확인 , 불만처리 등 민원처리 , 고지사항 전달\n-그 외, 서비스 이용과정에서 IP Address, 쿠키, 방문 일시, 결제 기록, 서비스 이용 기록이 자동으로 수집될 수 있습니다.\n단, 학점은행 교육과정 신청 시 수집된 주민등록번호는 아래 목적을 위해 활용됩니다.\n-평생교육법 및 학점인정 등에 관한 법률 시행령, 학점은행제 학사관리 지침 등의 규정에 따른 학사행정 업무\n3. 개인정보의 보유 및 이용기간\n회사는 동의 받은 개인정보 대하여 이용목적 달성 및 회원 탈퇴 시에는 지체 없이 파기합니다.\n다만, 관계법령이 규정에 의하여 보존할 필요가 있는 경우 회사는 아래와 같이 관계법령에서 정한 일정한 기간 동안 회원정보를 보유합니다\n(단, 기타 개별적으로 동의를 받은 경우에는 동의한 약정 기간 동안 보유합니다.',
   'register.terms.content.private': '1. 수집하는 개인정보의 항목\n회사는 회원가입, 상담, 서비스 신청 등을 위해 아래와 같은 개인정보를 수집하고 있습니다\n개인정보 수집방법에 따라 수집항목이 추가될 수 있습니다.\n\n\n1) 기본항목 수집방법 : 홈페이지 회원가입 및 서비스 제공에 관한 계약 이행시\n- 수집항목(필수) : 이름, 생년월일, 성별, 로그인ID, 비밀번호, 이메일, 휴대전화번호, 희망과정, 본인식별 정보 (아이핀인증가입시 DI)\n- 수집항목(선택) : 주소, 직업, 학력, 계좌번호, 추천인ID\n2) 추가항목 수집방법 : 학점은행 과정 수강신청시 최초1회\n\n- 수집항목 : 주민등록번호\n- 근거법령 : 학점인정 등에 관한 법률 시행령 제19조 2항\n3) 추가항목 수집방법 : 간편 로그인 사용시(SNS 계정 이용)\n\n- 네이버 계정 이용시 : 별명\n- 카카오 계정 이용시 : 프로필사진, 닉네임\n2. 개인정보의 수집 및 이용목적\n회사는 수집한 개인정보를 다음의 목적을 위해 활용합니다.\n\n-서비스 제공에 관한 계약 이행 및 서비스 제공에 따른 요금정산 : 콘텐츠 제공, 구매 및 요금 결제 , 물품배송 또는 청구지 등 발송\n-회원 관리 : 회원제 서비스 이용에 따른 본인확인 , 개인 식별 , 가입 의사 확인 , 불만처리 등 민원처리 , 고지사항 전달\n-그 외, 서비스 이용과정에서 IP Address, 쿠키, 방문 일시, 결제 기록, 서비스 이용 기록이 자동으로 수집될 수 있습니다.\n단, 학점은행 교육과정 신청 시 수집된 주민등록번호는 아래 목적을 위해 활용됩니다.\n-평생교육법 및 학점인정 등에 관한 법률 시행령, 학점은행제 학사관리 지침 등의 규정에 따른 학사행정 업무\n3. 개인정보의 보유 및 이용기간\n회사는 동의 받은 개인정보 대하여 이용목적 달성 및 회원 탈퇴 시에는 지체 없이 파기합니다.\n다만, 관계법령이 규정에 의하여 보존할 필요가 있는 경우 회사는 아래와 같이 관계법령에서 정한 일정한 기간 동안 회원정보를 보유합니다\n(단, 기타 개별적으로 동의를 받은 경우에는 동의한 약정 기간 동안 보유합니다.',
   'register.terms.content.company': '1. 수집하는 개인정보의 항목\n회사는 회원가입, 상담, 서비스 신청 등을 위해 아래와 같은 개인정보를 수집하고 있습니다\n개인정보 수집방법에 따라 수집항목이 추가될 수 있습니다.\n\n\n1) 기본항목 수집방법 : 홈페이지 회원가입 및 서비스 제공에 관한 계약 이행시\n- 수집항목(필수) : 이름, 생년월일, 성별, 로그인ID, 비밀번호, 이메일, 휴대전화번호, 희망과정, 본인식별 정보 (아이핀인증가입시 DI)\n- 수집항목(선택) : 주소, 직업, 학력, 계좌번호, 추천인ID\n2) 추가항목 수집방법 : 학점은행 과정 수강신청시 최초1회\n\n- 수집항목 : 주민등록번호\n- 근거법령 : 학점인정 등에 관한 법률 시행령 제19조 2항\n3) 추가항목 수집방법 : 간편 로그인 사용시(SNS 계정 이용)\n\n- 네이버 계정 이용시 : 별명\n- 카카오 계정 이용시 : 프로필사진, 닉네임\n2. 개인정보의 수집 및 이용목적\n회사는 수집한 개인정보를 다음의 목적을 위해 활용합니다.\n\n-서비스 제공에 관한 계약 이행 및 서비스 제공에 따른 요금정산 : 콘텐츠 제공, 구매 및 요금 결제 , 물품배송 또는 청구지 등 발송\n-회원 관리 : 회원제 서비스 이용에 따른 본인확인 , 개인 식별 , 가입 의사 확인 , 불만처리 등 민원처리 , 고지사항 전달\n-그 외, 서비스 이용과정에서 IP Address, 쿠키, 방문 일시, 결제 기록, 서비스 이용 기록이 자동으로 수집될 수 있습니다.\n단, 학점은행 교육과정 신청 시 수집된 주민등록번호는 아래 목적을 위해 활용됩니다.\n-평생교육법 및 학점인정 등에 관한 법률 시행령, 학점은행제 학사관리 지침 등의 규정에 따른 학사행정 업무\n3. 개인정보의 보유 및 이용기간\n회사는 동의 받은 개인정보 대하여 이용목적 달성 및 회원 탈퇴 시에는 지체 없이 파기합니다.\n다만, 관계법령이 규정에 의하여 보존할 필요가 있는 경우 회사는 아래와 같이 관계법령에서 정한 일정한 기간 동안 회원정보를 보유합니다\n(단, 기타 개별적으로 동의를 받은 경우에는 동의한 약정 기간 동안 보유합니다.',

   'register.input.title': 'UKMEDIA 회원 정보입력',
   'register.input.ment': 'UKMEDIA 서비스이용을 위해 회원 정보를 입력해 주세요.',
   'register.input.code.name': '소속코드 입력',
   'register.input.company.name': '회사명',
   'register.input.brand.name': '브랜드명',
   'register.input.location.name': '장소명',
   'register.input.id.name': '아이디',
   'register.input.password.name': '비밀번호',
   'register.input.repassword.name': '비밀번호 재확인',
   'register.input.manager.name': '담당자명',
   'register.input.phone.name': '전화번호',
   'register.input.code.placeholder': '소속코드를 입력해주세요.',
   'register.input.company.placeholder': '소속코드 입력시 자동입력 됩니다.',
   'register.input.id.placeholder': '사용하는 이메일 주소를 입력해 주세요.',
   'register.input.password.placeholder': '8~16자 영문 대 소문자, 숫자, 특수문자를 사용하세요.',
   'register.input.code.button': '검사',
   'register.input.code.error': '일치하는 코드가 없습니다. 다시 확인해 주세요.',
   'register.input.email.possible': '사용 가능한 이메일 주소입니다.',
   'register.input.email.error': '사용 불가능한 이메일 주소입니다. 다시 입력해 주세요.',
   'register.input.repassword.error': '비밀번호가 일치하지 않습니다.',
   'register.input.err.code': '소속코드를 입력하고 검사해 주세요.',
   'register.input.err.email': '이메일 주소를 검사해 주세요.',
   'register.input.err.password': '비밀번호를 입력하고 재확인해 주세요.',
   'register.input.err.name': '담당자명이 입력되지 않았습니다. 다시 확인해 주세요.',
   'register.input.err.phone': '전화번호가 입력되지 않았습니다. 다시 확인해 주세요.',
   'register.input.err.request': '요청에 실패하였습니다. 다시 시도해 주세요.',

   'register.input.button': '다음',

   'userInfo.id': '아이디',
   'userInfo.name': '이름',
   'userInfo.phone': '전화번호',
   'userInfo.role': '권한',
   'userInfo.company': '담당회사',
   'userInfo.brand': '담당브랜드',
   'userInfo.location': '담당장소',
   'userInfo.password.prev': '이전 비밀번호',
   'userInfo.password.cur': '비밀번호',
   'userInfo.password.re': '비밀번호 확인',
   
   'userInfo.update.success.title': '회원정보 수정 성공',
   'userInfo.update.success.content': '회원정보 수정에 성공했습니다.',
   'userInfo.update.error.password': '비밀번호가 틀렸습니다.',

}; 